<template>
  <div>
    <div class="max-w">
      <div class="in-infoBox" v-html="info.detail"></div>
    </div>
  </div>
</template>

<script>
import { getPage } from "@/api/web";
export default {
  data() {
    return {
      info: {},
    };
  },
  watch: {
    $route: {
      handler: function () {
        this.getInfo();
      },
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      getPage(this.$route.meta.id).then((res) => {
        this.info = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.in-infoBox{
     margin-top: 24px;
      line-height: 1.5;
      ::v-deep p {
        line-height: 1.5;
        margin: 1em 0;
        text-indent: 2em;
      }
      ::v-deep img{
        max-width: 100%;
        display: block;
      }
}
</style>
